import script from "./CustomKHQR.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomKHQR.vue?vue&type=script&setup=true&lang=js"

import "./CustomKHQR.vue?vue&type=style&index=0&id=1eb38abb&lang=css"

const __exports__ = script;

export default __exports__